import { Box } from "@outschool/backpack";
// This file is not yet translated.
/* eslint-disable i18next/no-literal-string */
import React from "react";

function isModifiedEvent(event: React.MouseEvent<HTMLDivElement, MouseEvent>) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}

type LinkReplacementProps = React.HTMLAttributes<HTMLDivElement> & {
  onClick: (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
  navigate: () => void;
};

/**
 * This can be passed into Link an NavLink in the component attribute
 * if you need to nest links inside it.
 */
const BoxLink = React.forwardRef(
  (
    { onClick, navigate, ...props }: LinkReplacementProps,
    ref: React.Ref<HTMLDivElement>
  ) => (
    <Box
      sx={{
        cursor: "pointer"
      }}
      ref={ref}
      {...props}
      onClick={(event: $TSFixMe) => {
        try {
          if (onClick) {
            onClick(event);
          }
        } catch (ex) {
          event.preventDefault();
          throw ex;
        }

        if (
          !event.defaultPrevented &&
          event.button === 0 &&
          !isModifiedEvent(event)
        ) {
          event.preventDefault();
          navigate();
        }
      }}
    />
  )
);

export default BoxLink;
